import script from "./AssigneeControl.vue?vue&type=script&setup=true&lang=js"
export * from "./AssigneeControl.vue?vue&type=script&setup=true&lang=js"

import "./AssigneeControl.vue?vue&type=style&index=0&id=cde5457c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cde5457c"]])

export default __exports__